import { render, staticRenderFns } from "./GoogleVoiceSearch.vue?vue&type=template&id=487afb96&scoped=true&"
import script from "./GoogleVoiceSearch.vue?vue&type=script&lang=js&"
export * from "./GoogleVoiceSearch.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=487afb96&prod&scoped=true&lang=css&"
import style1 from "./GoogleVoiceSearch.vue?vue&type=style&index=1&id=487afb96&prod&scoped=true&lang=css&"
import style2 from "./GoogleVoiceSearch.vue?vue&type=style&index=2&id=487afb96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487afb96",
  null
  
)

export default component.exports